<app-custom-modal
  #modal
  [title]="'Disponibilidade — ' + dataFormatada"
  [subtitle]="'Gerencie os horários disponíveis para este dia'"
  (onCloseClick)="fechar()"
  [hideCancel]="true"
  [hideSave]="true">

  <div class="container" *ngIf="!carregando; else loading">

    <!-- Lista de horários -->
    <div class="mb-4">
      <div class="d-flex align-items-center justify-content-between mb-3">
        <h6 class="font-weight-bold mb-0">Horários cadastrados</h6>
        <button *ngIf="eventos.length > 0 && !adicionando"
                class="btn btn-excluir-dia"
                [disabled]="salvando"
                (click)="confirmarExclusaoDia()">
          <i class="hgi hgi-stroke hgi-delete-02 mr-1"></i> Excluir dia inteiro
        </button>
      </div>

      <div *ngIf="eventos.length === 0" class="text-muted small mb-2">
        Nenhum horário disponível para este dia.
      </div>

      <div *ngFor="let ev of eventos" class="evento-card mb-2">

        <!-- Linha principal do evento -->
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <div class="d-flex align-items-center flex-wrap">
            <span class="horario-label mr-2">
              {{ ev.inicio | date:'HH:mm' }} – {{ ev.fim | date:'HH:mm' }}
            </span>
            <span class="badge-recorrencia mr-2" [ngClass]="ev.ehRecorrente ? 'badge-recorrente' : 'badge-avulso'">
              {{ ev.ehRecorrente ? 'Recorrente' : 'Avulso' }}
            </span>
            <span class="d-inline-flex align-items-center text-muted">
              <i class="hgi hgi-stroke hgi-user-circle mr-1" style="color:#6b7280;font-size:1.1rem;line-height:1;"></i>{{ nomeProfissional(ev.profissionalId) }}
            </span>
          </div>
          <div class="d-flex mt-1">
            <button class="btn btn-alterar-profissional mr-1"
                    [disabled]="salvando"
                    (click)="eventoEditandoId === ev.id ? cancelarEdicaoProfissional() : iniciarEdicaoProfissional(ev)"
                    title="Alterar profissional">
              <i class="hgi hgi-stroke hgi-user-edit-01 mr-1"></i>
              {{ eventoEditandoId === ev.id ? 'Cancelar' : 'Profissional' }}
            </button>
            <button class="btn btn-excluir-horario"
                    [disabled]="salvando"
                    (click)="confirmarExclusaoEvento(ev)">
              <i class="hgi hgi-stroke hgi-delete-02 mr-1"></i>Excluir
            </button>
          </div>
        </div>

        <!-- Painel inline de edição de profissional -->
        <div *ngIf="eventoEditandoId === ev.id" class="edicao-profissional mt-3">
          <label class="form-label required">Profissional</label>

          <div class="input-group mb-2">
            <div class="input-group-prepend">
              <span class="input-group-text">
                <i class="hgi hgi-stroke hgi-search-01" style="color:#6b7280"></i>
              </span>
            </div>
            <input type="text" class="form-control" placeholder="Busque pelo nome"
                   [(ngModel)]="nomeFiltroEdicao"
                   (ngModelChange)="filtrarProfissionaisEdicao($event)"
                   [disabled]="salvando" />
          </div>

          <div *ngIf="profissionaisFiltradosEdicao.length > 0" class="lista-profissionais mb-2">
            <div *ngFor="let ap of profissionaisFiltradosEdicao"
                 class="profissional-item"
                 (click)="selecionarProfissionalEdicao(ap)">
              <div class="user-foto-container">
                <img src="assets/img/user.png" alt="Foto do usuário">
              </div>
              <div class="profissional-info">
                <p class="nome-profissional mb-0">{{ ap.profissionalSaude?.nome }}</p>
                <p class="cpf-profissional mb-0">{{ ap.profissionalSaude?.cpf | cpfCnpj }}</p>
              </div>
            </div>
          </div>

          <div *ngIf="profissionalSelecionadoEdicao" class="profissional-selecionado mb-3">
            <div class="profissional-item profissional-item--selecionado">
              <div class="user-foto-container">
                <img src="assets/img/user.png" alt="Foto do usuário">
              </div>
              <div class="profissional-info flex-grow-1">
                <p class="nome-profissional mb-0">{{ profissionalSelecionadoEdicao.profissionalSaude?.nome }}</p>
                <p class="cpf-profissional mb-0">{{ profissionalSelecionadoEdicao.profissionalSaude?.cpf | cpfCnpj }}</p>
              </div>
              <button *ngIf="profissionaisDaAgenda.length > 1" class="btn icon icon-danger" title="Remover" (click)="removerProfissionalEdicao(); $event.stopPropagation()">
                <i class="hgi hgi-stroke hgi-delete-02"></i>
              </button>
            </div>
          </div>

          <div class="d-flex align-items-center">
            <button class="btn btn-cancelar mr-2" [disabled]="salvando" (click)="cancelarEdicaoProfissional()">
              Cancelar
            </button>
            <button class="btn btn-salvar-horario" [disabled]="salvando || !profissionalSelecionadoEdicao" (click)="salvarAlteracaoProfissional(ev)">
              <i class="hgi hgi-stroke hgi-tick-01"></i> Salvar
            </button>
          </div>
        </div>

      </div>
    </div>

    <hr />

    <!-- Botões Adicionar e Cancelar -->
    <div *ngIf="!adicionando">
      <button class="btn btn-adicionar mb-2" (click)="adicionando = true">
        <i class="hgi hgi-stroke hgi-add-circle"></i>
        <span>Adicionar horário</span>
      </button>
      <br />
      <button class="btn btn-cancelar btn-cancelar-lg" (click)="fechar()">
        Cancelar
      </button>
    </div>

    <!-- Formulário de novo horário -->
    <div *ngIf="adicionando">
      <h6 class="font-weight-bold mb-3">Adicionar horário</h6>

      <!-- Seletor de profissional -->
      <div *ngIf="profissionaisDaAgenda.length > 0" class="mb-3">
        <label class="form-label required">Profissional</label>

        <div class="input-group mb-2">
          <div class="input-group-prepend">
            <span class="input-group-text">
              <i class="hgi hgi-stroke hgi-search-01" style="color:#6b7280"></i>
            </span>
          </div>
          <input type="text" class="form-control" placeholder="Busque pelo nome"
                 [(ngModel)]="nomeFiltroNovo"
                 (ngModelChange)="filtrarProfissionaisNovo($event)"
                 [disabled]="salvando" />
        </div>

        <div *ngIf="profissionaisFiltradosNovo.length > 0" class="lista-profissionais mb-2">
          <div *ngFor="let ap of profissionaisFiltradosNovo"
               class="profissional-item"
               (click)="selecionarProfissionalNovo(ap)">
            <div class="user-foto-container">
              <img src="assets/img/user.png" alt="Foto do usuário">
            </div>
            <div class="profissional-info">
              <p class="nome-profissional mb-0">{{ ap.profissionalSaude?.nome }}</p>
              <p class="cpf-profissional mb-0">{{ ap.profissionalSaude?.cpf | cpfCnpj }}</p>
            </div>
          </div>
        </div>

        <div *ngIf="profissionalSelecionadoNovo" class="profissional-selecionado">
          <div class="profissional-item profissional-item--selecionado">
            <div class="user-foto-container">
              <img src="assets/img/user.png" alt="Foto do usuário">
            </div>
            <div class="profissional-info flex-grow-1">
              <p class="nome-profissional mb-0">{{ profissionalSelecionadoNovo.profissionalSaude?.nome }}</p>
              <p class="cpf-profissional mb-0">{{ profissionalSelecionadoNovo.profissionalSaude?.cpf | cpfCnpj }}</p>
            </div>
            <button *ngIf="profissionaisDaAgenda.length > 1" class="btn icon icon-danger" title="Remover" (click)="removerProfissionalNovo(); $event.stopPropagation()">
              <i class="hgi hgi-stroke hgi-delete-02"></i>
            </button>
          </div>
        </div>
      </div>

      <div class="form-row mb-3">
        <div class="col">
          <label class="form-label required">Início</label>
          <input type="time" class="form-control" [(ngModel)]="novoInicio" [disabled]="salvando" />
        </div>
        <div class="col">
          <label class="form-label required">Fim</label>
          <input type="time" class="form-control" [(ngModel)]="novoFim" [disabled]="salvando" />
        </div>
      </div>

      <div class="form-check mb-3">
        <input type="checkbox" class="form-check-input" id="ehRecorrente"
               [(ngModel)]="novoEhRecorrente" [disabled]="salvando" />
        <label class="form-check-label" for="ehRecorrente">
          Recorrente (todos os próximos dias equivalentes)
        </label>
      </div>

      <div *ngIf="novoEhRecorrente" class="mb-3">
        <label class="form-label">Data fim de recorrência <span class="text-muted small">(opcional)</span></label>
        <input type="date" class="form-control" [(ngModel)]="novaDataFimRecorrencia" [disabled]="salvando" />
      </div>

      <div class="d-flex align-items-center mt-2">
        <button class="btn btn-cancelar mr-2"
          [disabled]="salvando"
          (click)="cancelarAdicao()">
          Cancelar
        </button>
        <button class="btn btn-salvar-horario"
          [disabled]="salvando || !novoInicio || !novoFim || (profissionaisDaAgenda.length > 0 && !profissionalSelecionadoNovo)"
          (click)="adicionarHorario()">
          <i class="hgi hgi-stroke hgi-tick-01"></i>
          Salvar horário
        </button>
      </div>
    </div>

  </div>

  <ng-template #loading>
    <div class="text-center py-4">
      <i class="hgi hgi-stroke hgi-loading-01 fa-spin"></i> Carregando...
    </div>
  </ng-template>

</app-custom-modal>
